<template>
	<div class="addOfficial">
		<el-form :model="form" ref="ruleFormAdd">
			 <el-form-item label="名称：" required :label-width="formLabelWidth">
			    <el-input v-model="form.name"></el-input>
			  </el-form-item>
			  <el-form-item label="appID：" required :label-width="formLabelWidth">
			     <el-input v-model="form.appId"></el-input>
			   </el-form-item>
			   <el-form-item label="appSecret：" required  :label-width="formLabelWidth">
			      <el-input v-model="form.appSecret"></el-input>
			    </el-form-item>
				  <el-form-item label="地理位置权限是否已开启:" required  :label-width="formLabelWidth">
					<el-select v-model="form.locateFlag">
					<el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
					</el-select>
			      <!-- <el-input v-model="form.locateFlag"></el-input> -->
			    </el-form-item>
			   		
		
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="baseFormSubmit()" class="themed-button">确 定</el-button>
			<el-button type="primary" @click="baseFormReset('ruleFormAdd')" class="themed-button">重 置</el-button>
			<el-button  type="info" @click="cancelDialog" class="themed-button">取 消</el-button>
		</div>
	</div>
</template>

<script>
	import  loading from "@/utils/Loading.js"
	import {addOfficialList,} from "@/api/payManagment.js"
	export default{
		name:'addOfficial',
		data(){
			return {
			form:{
			name:""	,
			appId:"",
			appSecret:"",
			locateFlag:""
			},
			formLabelWidth:'180px'
			}
		},
		methods:{
			baseFormSubmit(){
			if(this.form.name == null ||this.form.name  ==""||this.form.name ==0 ){
				this.$alert('请填写名称', '系统提示', {
				          confirmButtonText: '确定',
				        });
						return 
			}
				if(this.form.appId == null ||this.form.appId  ==""||this.form.appId ==0 ){
					this.$alert('请填写公众号ID！', '系统提示', {
					          confirmButtonText: '确定',
					        });
							return
				}
				if(this.form.appSecret == null ||this.form.appSecret  ==""||this.form.appSecret ==0 ){
					this.$alert('请填写秘钥！', '系统提示', {
					          confirmButtonText: '确定',
					        });
							return
				}
				if(this.form.locateFlag == null ||this.form.locateFlag  ==""){
                  this.$alert('请选择地理位置权限开关','系统提示',{
					          confirmButtonText:"确定",
				  })
				  return
				}
				loading.show()
				addOfficialList(this.form).then(res=>{
					if(res.slide_msg_key==1){
						this.$alert(res.slide_msg_message_key,"消息提示")
						return ;
					}
					this.$emit("reload")
					this.$emit("close")
					
				})
			},
			baseFormReset(formName){
				//this.$refs[formName].resetFields();
				this.form.name = ""
				this.form.appId = ""
				this.form.appSecret = ""
				this.form.locateFlag = ""
			},
			cancelDialog(){
				console.log("close")
				this.$emit("close")
			}
		}
	}
</script>

<style>
	.addOfficial .dialog-footer{
		text-align: right;
	}
</style>
